const airports = [
{ name:"Hartsfield-Jackson Atlanta International Airport",code:"ATL",country:"USA"},
{ name:"Los Angeles International Airport",code:"LAX",country:"USA"},
{ name:"Chicago O'Hare International Airport",code:"ORD",country:"USA"},
{ name:"Dallas/Fort Worth International Airport",code:"DFW",country:"USA"},
{ name:"Denver International Airport",code:"DEN",country:"USA"},
{ name:"John F. Kennedy International Airport",code:"JFK",country:"USA"},
{ name:"San Francisco International Airport",code:"SFO",country:"USA"},
{ name:"Seattle-Tacoma International Airport",code:"SEA",country:"USA"},
{ name:"Miami International Airport",code:"MIA",country:"USA"},
{ name:"Houston George Bush Intercontinental Airport",code:"IAH",country:"USA"},
{ name:"Newark Liberty International Airport",code:"EWR",country:"USA"},
{ name:"Boston Logan International Airport",code:"BOS",country:"USA"},
{ name:"Washington Dulles International Airport",code:"IAD",country:"USA"},
{ name:"New York LaGuardia Airport",code:"LGA",country:"USA"},
{ name:"Orlando International Airport",code:"MCO",country:"USA"},
{ name:"Las Vegas McCarran International Airport",code:"LAS",country:"USA"},

{ name:"Toronto Pearson International Airport",code:"YYZ",country:"Canada"},
{ name:"Vancouver International Airport",code:"YVR",country:"Canada"},
{ name:"Montreal Trudeau Airport",code:"YUL",country:"Canada"},

{ name:"London Heathrow Airport",code:"LHR",country:"UK"},
{ name:"London Gatwick Airport",code:"LGW",country:"UK"},
{ name:"London Stansted Airport",code:"STN",country:"UK"},
{ name:"Manchester Airport",code:"MAN",country:"UK"},
{ name:"Birmingham Airport",code:"BHX",country:"UK"},
{ name:"Dublin Airport",code:"DUB",country:"Ireland"},

{ name:"Paris Charles de Gaulle Airport",code:"CDG",country:"France"},
{ name:"Paris Orly Airport",code:"ORY",country:"France"},
{ name:"Nice Côte d'Azur Airport",code:"NCE",country:"France"},

{ name:"Frankfurt Airport",code:"FRA",country:"Germany"},
{ name:"Munich Airport",code:"MUC",country:"Germany"},
{ name:"Berlin Brandenburg Airport",code:"BER",country:"Germany"},
{ name:"Hamburg Airport",code:"HAM",country:"Germany"},
{ name:"Düsseldorf Airport",code:"DUS",country:"Germany"},

{ name:"Amsterdam Schiphol Airport",code:"AMS",country:"Netherlands"},
{ name:"Brussels Airport",code:"BRU",country:"Belgium"},
{ name:"Zurich Airport",code:"ZRH",country:"Switzerland"},
{ name:"Geneva Airport",code:"GVA",country:"Switzerland"},
{ name:"Vienna International Airport",code:"VIE",country:"Austria"},

{ name:"Madrid Barajas Airport",code:"MAD",country:"Spain"},
{ name:"Barcelona El Prat Airport",code:"BCN",country:"Spain"},
{ name:"Palma de Mallorca Airport",code:"PMI",country:"Spain"},
{ name:"Malaga Airport",code:"AGP",country:"Spain"},
{ name:"Valencia Airport",code:"VLC",country:"Spain"},

{ name:"Rome Fiumicino Airport",code:"FCO",country:"Italy"},
{ name:"Milan Malpensa Airport",code:"MXP",country:"Italy"},
{ name:"Milan Linate Airport",code:"LIN",country:"Italy"},
{ name:"Venice Marco Polo Airport",code:"VCE",country:"Italy"},
{ name:"Naples International Airport",code:"NAP",country:"Italy"},

{ name:"Athens International Airport",code:"ATH",country:"Greece"},
{ name:"Budapest Airport",code:"BUD",country:"Hungary"},
{ name:"Prague Airport",code:"PRG",country:"Czech Republic"},
{ name:"Warsaw Chopin Airport",code:"WAW",country:"Poland"},
{ name:"Copenhagen Airport",code:"CPH",country:"Denmark"},
{ name:"Stockholm Arlanda Airport",code:"ARN",country:"Sweden"},
{ name:"Oslo Gardermoen Airport",code:"OSL",country:"Norway"},
{ name:"Helsinki Airport",code:"HEL",country:"Finland"},

{ name:"Istanbul Airport",code:"IST",country:"Turkey"},
{ name:"Istanbul Sabiha Gökçen Airport",code:"SAW",country:"Turkey"},
{ name:"Ankara Esenboğa Airport",code:"ESB",country:"Turkey"},

{ name:"Dubai International Airport",code:"DXB",country:"UAE"},
{ name:"Dubai Al Maktoum Airport",code:"DWC",country:"UAE"},
{ name:"Abu Dhabi International Airport",code:"AUH",country:"UAE"},
{ name:"Doha Hamad International Airport",code:"DOH",country:"Qatar"},
{ name:"Kuwait International Airport",code:"KWI",country:"Kuwait"},
{ name:"Riyadh King Khalid Airport",code:"RUH",country:"Saudi Arabia"},
{ name:"Jeddah King Abdulaziz Airport",code:"JED",country:"Saudi Arabia"},

{ name:"Cairo International Airport",code:"CAI",country:"Egypt"},
{ name:"Casablanca Mohammed V Airport",code:"CMN",country:"Morocco"},
{ name:"Tunis Carthage Airport",code:"TUN",country:"Tunisia"},
{ name:"Addis Ababa Bole Airport",code:"ADD",country:"Ethiopia"},
{ name:"Johannesburg OR Tambo Airport",code:"JNB",country:"South Africa"},
{ name:"Cape Town International Airport",code:"CPT",country:"South Africa"},

{ name:"Delhi Indira Gandhi Airport",code:"DEL",country:"India"},
{ name:"Mumbai Chhatrapati Shivaji Airport",code:"BOM",country:"India"},
{ name:"Bangalore Kempegowda Airport",code:"BLR",country:"India"},
{ name:"Singapore Changi Airport",code:"SIN",country:"Singapore"},
{ name:"Bangkok Suvarnabhumi Airport",code:"BKK",country:"Thailand"},
{ name:"Hong Kong International Airport",code:"HKG",country:"Hong Kong"},
{ name:"Tokyo Haneda Airport",code:"HND",country:"Japan"},
{ name:"Tokyo Narita Airport",code:"NRT",country:"Japan"},
{ name:"Seoul Incheon Airport",code:"ICN",country:"South Korea"},
{ name:"Beijing Capital Airport",code:"PEK",country:"China"},
{ name:"Shanghai Pudong Airport",code:"PVG",country:"China"},

{ name:"Sydney Airport",code:"SYD",country:"Australia"},
{ name:"Melbourne Airport",code:"MEL",country:"Australia"},
{ name:"Brisbane Airport",code:"BNE",country:"Australia"},
{ name:"Auckland Airport",code:"AKL",country:"New Zealand"},

{ name:"Mexico City International Airport",code:"MEX",country:"Mexico"},
{ name:"São Paulo Guarulhos Airport",code:"GRU",country:"Brazil"},
{ name:"Buenos Aires Ezeiza Airport",code:"EZE",country:"Argentina"},
{ name:"Lima Jorge Chávez Airport",code:"LIM",country:"Peru"},
{ name:"Bogotá El Dorado Airport",code:"BOG",country:"Colombia"}
];

export default airports;